import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material';
import {FormControl} from '@angular/forms';

export interface DialogData {
    control: FormControl;
    text: string[];
}

@Component({
    selector: 'app-field-value-modal',
    templateUrl: './field-value-modal.component.html',
    styleUrls: ['./field-value-modal.component.scss']
})
export class FieldValueModalComponent implements OnInit {

    controlLocal: FormControl;

    constructor(
        public dialogRef: MatDialogRef<FieldValueModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: DialogData) {
    }

    ngOnInit() {
        this.controlLocal = Object.create(this.data.control);
        this.controlLocal.setValue("");
    }

    getErrorMessage(): string {
        return this.data.control.hasError('required') || this.data.control.hasError('defaultValue')
            ? 'Debe completar este campo'
            : '';
    }

    updateValue(): void {
        this.data.control.setValue(this.controlLocal.value);
        this.dialogRef.close();
    }

}



// WEBPACK FOOTER //
// ./src/app/form-views/components/field-value-modal/field-value-modal.component.ts